export function getSortedColumns(columns) {
  return Object.values(columns).sort((left, right) => left.index - right.index)
}
